import React from 'react';
import clsx from 'clsx';

const TabLabel = ({ tab }) => {
  if (tab) {
    return (
      <>
        <i className={clsx('faux_tab_icon fa', tab.icon)} />
        <span className="tab_title" title={tab.tooltip}>
          {tab.name}
          {' '}
        </span>
      </>
    );
  }

  return (
    <span />
  );
};

export default TabLabel;
